<template>
  <div>
    <!--hero header-->
    <section class="pb-6" id="home">
      <!-- <Introbar /> -->
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-12 mx-auto mt-6 text-center">
            <h1>One-Click, Inline Replies in Gmail</h1>
            <p class="lead mt-3 mb-4">Send better emails faster</p>
            <!-- ADD TO CHROME BUTTON -->
            <div class="store-buttons">
              <a
                href="https://chrome.google.com/webstore/detail/reply-ninja/emhaoogbfmegmgmcdenlgdohlloflgij?authuser=1"
                class="mx-2 my-2 btn btn-outline-primary d-inline-flex flex-row align-items-center storeLink"
              >
                <img class="ff-icon" src="@/assets/images/chrome_logo.svg" alt /> Add to Chrome
                <small class="ml-2"></small>
              </a>
              <!-- ADD TO FIREFOX BUTTON -->
              <a
                href="https://addons.mozilla.org/en-US/firefox/addon/reply-ninja"
                class="mx-2 my-2 btn btn-outline-primary d-inline-flex flex-row align-items-center storeLink"
              >
                <img class="ff-icon" src="@/assets/images/firefox_logo.svg" alt /> Add to Firefox
                <small class="ml-2"></small>
              </a>
            </div>
            <div class="rating-stars mt-4">
              <span class="fa fa-star"></span>
              <span class="fa fa-star"></span>
              <span class="fa fa-star"></span>
              <span class="fa fa-star"></span>
              <span class="fa fa-star"></span>
            </div>
            <p class="text-muted small">We must be doing something right</p>
            <!-- <p class="text-muted small"> (1,000+ <a href="#" class="text-muted">reviews</a> by 300,000 +users) </p> -->
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 mx-auto text-center">
            <img
              class="img-fluid img-raised d-block mx-auto rounded"
              src="@/assets/images/ReplyNinja_bg.png"
              alt="Mockup"
            />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12 mx-auto">
            <div class="row text-left">
              <div class="col-md-4 col-6">
                <div class="media d-flex align-items-center flex-row">
                  <img class="mid-icon" src="@/assets/images/CH_FF.svg" alt />
                  <div class="media-body">
                    <h3 class="text-muted mb-1 d-block helvetica">1500+</h3>
                    <span class="text-muted small-xl">Plugin installations</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="media d-flex align-items-center flex-row">
                  <img class="mid-icon" src="@/assets/images/send.svg" alt />
                  <div class="media-body">
                    <h3 class="text-muted mb-1 text-left d-block odometer-video helvetica">100,000+</h3>
                    <span class="text-muted text-left small-xl">Formatted emails sent</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6 mx-auto mt-4 mt-md-0">
                <div class="media d-flex flex-row">
                  <img class="mid-icon pad-top" src="@/assets/images/heart.svg" alt />
                  <div class="media-body">
                    <div class="rating-stars inverse">
                      <span class="fa fa-star"></span>
                      <span class="fa fa-star"></span>
                      <span class="fa fa-star"></span>
                      <span class="fa fa-star"></span>
                      <span class="fa fa-star"></span>
                    </div>
                    <span class="text-muted small-xl">From our fans</span>
                    <!-- <span class="text-muted small-xl">1,000+ reviews</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="pb-6" id="features">
      <div class="col-md-8 mx-auto text-center">
        <h2 class="pb-5">How does it work?</h2>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/jwqORB6ANo4" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </section>
    <!-- press section -->
    <section class="py-6 bg-light" id="press">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto text-center">
            <h3 class="display-4">Send killer emails fast!</h3>
            <p class="text-muted">&mdash; Growth Ninja</p>
          </div>
        </div>
        <div class="row press mt-5">
          <div
            class="col-12 text-muted small-xl text-uppercase text-center mb-5"
          >Trusted by people at companies like</div>
          <div class="press-item col-lg-4 col-md-4">
            <img class="img-fluid" src="@/assets/images/press/press-1.png" alt />
          </div>
          <div class="press-item col-lg-4 col-md-4">
            <img class="img-fluid" src="@/assets/images/press/press-2.png" alt />
          </div>
          <div class="press-item col-lg-4 col-md-4">
            <img class="img-fluid" src="@/assets/images/press/press-3.png" alt />
          </div>
        </div>
      </div>
    </section>
    <!-- features section -->
    <!-- <section class="py-6" id="features">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto text-center">
            <h2>More than just professional formatting</h2>
            <p class="lead text-muted">(These feature are coming soon!)</p>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-4">
            <div class="nav flex-column nav-tabs nav-features" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <a class="nav-link-tab active" id="v-tab1-tab" data-toggle="tab" href="#v-tab1" role="tab" aria-controls="v-tab1" aria-selected="true">
                <div class="card card-body">
                  <h6>
                    <em class="feather-icon mr-2" data-feather="message-square" height="20" width="20"></em> Instant, inline replies </h6> Click what you want to respond to and watch it format your email automatically.
                </div>
              </a>
              <a class="nav-link-tab" id="v-tab2-tab" data-toggle="tab" href="#v-tab2" role="tab" aria-controls="v-tab2" aria-selected="false">
                <div class="card card-body">
                  <h6>
                    <em class="feather-icon mr-2" data-feather="crosshair" height="20" width="20"></em> Track email opens (COMING SOON) </h6> Steathily see which emails have been opened.
                </div>
              </a>
              <a class="nav-link-tab" id="v-tab3-tab" data-toggle="tab" href="#v-tab3" role="tab" aria-controls="v-tab3" aria-selected="false">
                <div class="card card-body">
                  <h6>
                    <em class="feather-icon mr-2" data-feather="clipboard" height="20" width="20"></em> Custom templates (COMING SOON) </h6> Save custom text snippets for replies you use often.
                </div>
              </a>
              <a class="nav-link-tab" id="v-tab4-tab" data-toggle="tab" href="#v-tab4" role="tab" aria-controls="v-tab4" aria-selected="false">
                <div class="card card-body">
                  <h6>
                    <em class="feather-icon mr-2" data-feather="target" height="20" width="20"></em> High-converting templates (COMING SOON) </h6> Utilize our library of high-converting, marketing templates.
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-8 my-auto">
            <div class="tab-content" id="v-pills-tabContent">
              <div class="tab-pane fade show active" id="v-tab1" role="tabpanel" aria-labelledby="v-tab1-tab">
                <img src="img/feature-1.png" class="img-fluid d-block mx-auto" alt="Feature 1" />
              </div>
              <div class="tab-pane fade" id="v-tab2" role="tabpanel" aria-labelledby="v-tab2-tab">
                <img src="img/feature-2.png" class="img-fluid d-block mx-auto" alt="Feature 2" />
              </div>
              <div class="tab-pane fade" id="v-tab3" role="tabpanel" aria-labelledby="v-tab3-tab">
                <img src="img/feature-3.png" class="img-fluid d-block mx-auto" alt="Feature 3" />
              </div>
              <div class="tab-pane fade" id="v-tab4" role="tabpanel" aria-labelledby="v-tab4-tab">
                <img src="img/feature-4.png" class="img-fluid d-block mx-auto" alt="Feature 4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->
    <!--pricing section-->
    <!-- <section class="pt-6 pb-6 bg-light pricing" id="pricing">
      <div class="container">
        <div class="row">
          <div class="col-10 mx-auto text-center">
            <h2 class="dark-text">Simple Pricing</h2>
            <p class="lead text-muted">
              Get started for free. No credit card required.
            </p>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-sm-12 col-lg-8 mx-auto">
            <div class="card-group pricing-table">
              <div class="card text-center">
                <div class="card-body">
                  <h5 class="card-title pt-3 dark-text">Basic</h5>
                  <h2 class="card-title display-4 text-primary pt-4">Free</h2>
                  <div class="text-muted lead mt-4">Forever</div>
                  <ul class="list-unstyled pricing-list dark-text">
                    <li>15 formats</li>
                    <li>30 tracked opens</li>
                    <li>5 custom templates</li>
                    <li>Basic marketing templates</li>
                    <li>Basic support</li>
                  </ul>
                  <a
                    href="#"
                    class="btn btn-outline-dark d-inline-flex flex-row align-items-center"
                  >
                    <em
                      class="mr-2"
                      data-feather="chrome"
                      height="20"
                      width="20"
                    ></em>
                    Add to chrome
                  </a>
                </div>
              </div>
              <div class="card bg-dark text-center">
                <div class="card-body">
                  <h5 class="card-title text-white pt-3">Unlimited</h5>
                  <h2 class="card-title display-4 text-primary pt-4">$4</h2>
                  <div class="text-muted lead mt-4">Per User / Month</div>
                  <ul class="list-unstyled text-light pricing-list">
                    <li>Unlimited formats</li>
                    <li>Stealth open tracking</li>
                    <li>Unlimited Custom templates</li>
                    <li>Premium marketing templates</li>
                    <li>Premium support</li>
                  </ul>
                  <a href="/upgrade" class="btn btn-primary">
                    Upgrade to premium
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-6">
          <div class="col-md-6 mx-auto text-center smooth-scroll">
            <h4 class="dark-text">Cancel Anytime.</h4>
            <p class="text-muted mb-4">
              We know you'll love ReplyNinja Unlimited. <br />If you don't,
              cancellation is easy and instant.
            </p>
            <a
              href="#"
              class="btn btn-link d-flex flex-row align-items-center justify-content-center"
            >
              Get started now <em class="ml-2" data-feather="arrow-right"></em>
            </a>
          </div>
        </div>
      </div>
    </section>-->
    <div class="phCTA-wrap">
      <a
        href="https://www.producthunt.com/posts/reply-ninja-2?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-reply-ninja-2"
        target="_blank"
        class="phCTA mb-5 mt-4"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=164257&theme=light&period=daily"
          alt="Reply Ninja - Instant Inline replies in Gmail | Product Hunt Embed"
          style="width: 250px; height: 54px;"
          width="250px"
          height="54px"
        />
      </a>
    </div>
  </div>
</template>

<script>
// import Introbar from "@/components/common/Introbar";

export default {
  name: "landing",
  components: {
    // Introbar
  }
};
</script>

<style lang="scss" scope>
.phCTA-wrap {
  margin: 30px auto;
}
</style>
